export class SequenceID {
    private number = 0;
    private session = Math.random().toString(36).slice(2);

    public next(): string {
        this.number += 1;
        return `${this.session}-${this.number}`;
    }
}
